<template>
  <div class="">
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="85%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="editFormRules"
        class="demo-editForm"
        label-width="160px"
      >
        <el-form-item label="商品名：" prop="name">
          <el-input v-model="editForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品分类：" prop="classifyId">
          <el-cascader
            ref="cateData"
            v-model="classifyId"
            :options="typeList"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            clearable
            filterable
            placeholder="选择分类"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="是否可拼团：" prop="isGroupBuying">
          <el-radio-group v-model="editForm.isGroupBuying">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="editForm.isGroupBuying === 1"
          label="拼团人数："
          prop="groupBuyingNum"
        >
          <el-input
            v-model="editForm.groupBuyingNum"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否是限时秒杀：" prop="isLimitedTimeDiscount">
          <el-radio-group v-model="editForm.isLimitedTimeDiscount">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="editForm.isLimitedTimeDiscount === 1"
          label="限时秒杀人数："
          prop="limitedTimeDiscountNum"
        >
          <el-input
            v-model="editForm.limitedTimeDiscountNum"
            autocomplete="off"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="editForm.isLimitedTimeDiscount === 1"
          label="限时秒杀时效："
          prop="limitedTimeDiscountEndTime"
        >
          <el-date-picker
            v-model="editForm.limitedTimeDiscountEndTime"
            v-bind="datePickerConfig"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="editForm.isLimitedTimeDiscount === 1"
          label="限时秒杀件数："
          prop="limitedTimeDiscountCommodityNum"
        >
          <el-input
            v-model="editForm.limitedTimeDiscountCommodityNum"
            autocomplete="off"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否是众筹商品：" prop="isCrowdfunding">
          <el-radio-group v-model="editForm.isCrowdfunding">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="editForm.isCrowdfunding === 1"
          label="众筹开始时间："
          prop="crowdfundingStartTime"
        >
          <el-date-picker
            v-model="editForm.crowdfundingStartTime"
            v-bind="datePickerConfig"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="editForm.isCrowdfunding === 1"
          label="众筹结束时间："
          prop="crowdfundingEndTime"
        >
          <el-date-picker
            v-model="editForm.crowdfundingEndTime"
            v-bind="datePickerConfig"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="editForm.isCrowdfunding === 1"
          label="众筹发货时间："
          prop="crowdfundingDeliveryTime"
        >
          <el-date-picker
            v-model="editForm.crowdfundingDeliveryTime"
            v-bind="datePickerConfig"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="editForm.isCrowdfunding === 1"
          label="众筹可抽奖人数："
          prop="crowdfundingLuckyNum"
        >
          <el-input-number
            v-model="editForm.crowdfundingLuckyNum"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          v-if="editForm.isCrowdfunding === 1"
          label="众筹幸运用户数："
          prop="crowdfundingLuckyUser"
        >
          <el-input-number
            v-model="editForm.crowdfundingLuckyUser"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="是否为赠品：" prop="isGift">
          <el-radio-group v-model="editForm.isGift">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否可积分兑换：" prop="isPoint">
          <el-radio-group v-model="editForm.isPoint">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="商品规格：" prop="commoditSpecificationsList">
          <div
            style="margin-bottom: 10px"
            v-for="(item, index) in editForm.commoditSpecificationsList"
            :key="index"
          >
            <el-divider content-position="center"
              >商品规格配置--{{ index + 1 }}</el-divider
            >
            <el-row>
              <el-col style="margin-bottom: 8px" :span="24">
                <el-form-item :label="'规格名:'" label-width="120px">
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .commoditSpecifications
                    "
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col style="margin-bottom: 8px" :span="8">
                <el-form-item label="产品原价：" label-width="120px">
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index].originalPrice
                    "
                    type="number"
                    :min="0"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col style="margin-bottom: 8px" :span="8">
                <el-row>
                  <el-col :span="10" :offset="3"
                    ><el-input
                      v-model="
                        editForm.commoditSpecificationsList[index]
                          .sellingPriceName
                      "
                      autocomplete="off"
                      placeholder="售价名称"
                    ></el-input
                  ></el-col>
                  <el-col :span="1">
                    <div style="text-align: center">:</div>
                  </el-col>
                  <el-col :span="10"
                    ><el-input
                      v-model="editForm.commoditSpecificationsList[index].price"
                      autocomplete="off"
                      type="number"
                      :min="0"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-col>

              <el-col style="margin-bottom: 8px" :span="8">
                <el-row>
                  <el-col :span="10" :offset="3"
                    ><el-input
                      v-model="
                        editForm.commoditSpecificationsList[index]
                          .storePriceName
                      "
                      autocomplete="off"
                      placeholder="达人售价名称"
                    ></el-input
                  ></el-col>
                  <el-col :span="1">
                    <div style="text-align: center">:</div>
                  </el-col>
                  <el-col :span="10"
                    ><el-input
                      v-model="
                        editForm.commoditSpecificationsList[index].storePrice
                      "
                      autocomplete="off"
                      type="number"
                      :min="0"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-col>

              <el-col
                style="margin-bottom: 8px"
                :span="8"
                v-if="editForm.isGift === 1"
              >
                <el-form-item label="产品库存：" label-width="120px">
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index].inventory
                    "
                    type="number"
                    :min="0"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col
                :span="8"
                style="margin-bottom: 8px"
                v-if="editForm.isGroupBuying === 1"
              >
                <el-form-item label="拼团价：" label-width="120px">
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .groupBuyingPrice
                    "
                    type="number"
                    :min="0"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                style="margin-bottom: 8px"
                v-if="editForm.isLimitedTimeDiscount === 1"
              >
                <el-form-item label="秒杀价：" label-width="120px">
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .limitedTimeDiscountPrice
                    "
                    type="number"
                    :min="0"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                style="margin-bottom: 8px"
                v-if="editForm.isCrowdfunding === 1"
              >
                <el-form-item label="全款众筹价：" label-width="120px">
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .crowdfundingPrice
                    "
                    type="number"
                    :min="0"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                style="margin-bottom: 8px"
                v-if="editForm.isCrowdfunding === 1"
              >
                <el-form-item label="抽奖众筹价：" label-width="120px">
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .crowdfundingLotteryPrice
                    "
                    type="number"
                    :min="0"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" style="margin-bottom: 8px">
                <el-form-item label="签收送积分：" label-width="120px">
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index].pointsNum
                    "
                    type="number"
                    :min="0"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                style="margin-bottom: 8px"
                v-if="editForm.isPoint === 1"
              >
                <el-form-item label="兑换需积分：" label-width="120px">
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .exchangePointsNum
                    "
                    type="number"
                    :min="0"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row
              style="margin-top: 10px"
              v-for="(items, indexs) in editForm.commoditSpecificationsList[
                index
              ].tcommodityFlashSalePrices"
              :key="indexs"
            >
              <el-col style="text-align: center" :span="3">
                单价区间{{ indexs + 1 }} :
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .tcommodityFlashSalePrices[indexs].startNum
                    "
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col style="text-align: center; width: 20px"> 至 </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .tcommodityFlashSalePrices[indexs].endNum
                    "
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col style="text-align: center" :span="3">
                每件单价/元：
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .tcommodityFlashSalePrices[indexs].price
                    "
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="4" style="text-align: center">
                <el-button
                  circle
                  type="success"
                  style="margin-right: 20px"
                  icon="el-icon-plus"
                  @click="addFlashSalePrice(index, indexs)"
                ></el-button>
                <el-button
                  circle
                  type="danger"
                  icon="el-icon-delete"
                  @click="delFlashSalePrice(index, indexs)"
                ></el-button>
              </el-col>
            </el-row>
            <div style="text-align: center; margin-top: 20px">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addSpecification(index)"
                >添加规格</el-button
              >
              <el-button
                type="danger"
                icon="el-icon-delete"
                @click="delSpecification(index)"
                >删除规格</el-button
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="单位：" prop="unit">
          <el-input v-model="editForm.unit" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品标签：" prop="productLabelsList">
          <div
            v-for="(item, index) in editForm.productLabelsList"
            :key="index"
            style="margin-bottom: 10px"
          >
            <el-row>
              <el-col :span="18">
                <el-input
                  v-model="editForm.productLabelsList[index]"
                  autocomplete="off"
                ></el-input>
              </el-col>
              <el-col :span="6" style="text-align: center">
                <el-button
                  circle
                  type="success"
                  icon="el-icon-plus"
                  style="margin-right: 20px"
                  @click="addLabel(index)"
                ></el-button>
                <el-button
                  circle
                  type="danger"
                  icon="el-icon-delete"
                  @click="delLabel(index)"
                ></el-button>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="商品参数：" prop="parameters">
          <el-input v-model="editForm.parameters" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否是热门：" prop="isHot">
          <el-radio-group v-model="editForm.isHot">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否推荐：" prop="isRecommend">
          <el-radio-group v-model="editForm.isRecommend">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否是新品上市：" prop="isNewProductLaunch">
          <el-radio-group v-model="editForm.isNewProductLaunch">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品说明：" prop="explain">
          <el-input v-model="editForm.explain" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="运费：" prop="freight">
          <el-input v-model="editForm.freight" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="sort">
          <el-input v-model="editForm.sort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="dialogVisible" label="商品详情：" prop="imgDetail">
          <Editor
            v-model="editForm.imgDetail"
            :min-height="192"
            @change="handleDetailChange"
          />
        </el-form-item>
        <el-form-item
          v-if="dialogVisible"
          label="三证信息:"
          prop="threeCertificateInformation"
        >
          <Editor
            v-model="editForm.threeCertificateInformation"
            :min-height="192"
            @change="handleThreeCertChange"
          />
        </el-form-item>
        <el-form-item
          label="封面(尺寸570:320):"
          label-width="140px"
          prop="videoCover"
        >
          <VploadImgs
            :limit="1"
            :multble="false"
            :type="1"
            :file-list="filesd"
            @submitImg="handleCoverImageChange"
          >
          </VploadImgs>
        </el-form-item>
        <div style="height: 30px"></div>
        <el-form-item
          label="轮播图(尺寸1:1):"
          label-width="140px"
          prop="imgList"
        >
          <VploadImgFour
            :fileData="fileData"
            :fileSize="fileSize"
            :fileType="fileType"
            :limit="10"
            :value="editForm.imgList"
            @input="getImgList"
          >
          </VploadImgFour>
        </el-form-item>
        <el-form-item align="center">
          <el-button type="primary" @click="handleSave">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import VploadImgs from "../../inc/VploadImgThree";
import VploadImgFour from "../../inc/VploadImgFour";
import Editor from "@/components/Tinymce/index";
import { parseTime } from "@/utils";

const DATE_FORMAT = "yyyy-MM-dd HH:mm:ss";
const DATE_PICKER_CONFIG = {
  type: "datetime",
  format: DATE_FORMAT,
  "value-format": DATE_FORMAT,
  placeholder: "选择日期时间",
  style: "width: 100%",
};

export default {
  name: "SingProduct",
  components: {
    VploadImgs,
    Editor,
    VploadImgFour,
  },
  props: {
    storeGoodsId: {
      type: Number,
    },
    storeGoodsStatus: {
      type: Number,
    },
  },
  data() {
    return {
      fileData: {
        type: 0,
        fileType: 0,
      },
      fileType: ["png", "jpg", "jpeg"],
      fileSize: 5,
      editForm: {
        imgList: "",
        imgDetail: "",
      },
      filesd: [],
      typeList: [],
      supList: [],
      commodityId: "",
      isEdit: false,
      dialogVisible: true,
      classifyId: [],
      dialogTitle: "添加商品",
      coverImageList: [],
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入商品名",
            trigger: "blur",
          },
        ],
        explain: [
          {
            required: true,
            message: "请输入商品说明",
            trigger: "blur",
          },
        ],
        parameters: [
          {
            required: true,
            message: "请输入商品参数",
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: "请输入单位",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    datePickerConfig() {
      return DATE_PICKER_CONFIG;
    },
  },
  created() {
    this.getTypeList();
    this.getBrandList();
  },
  methods: {
    getDefaultSpecification() {
      return {
        commoditId: "",
        commoditSpecifications: "",
        commoditSpecificationsId: 0,
        inventory: 0,
        originalPrice: 0,
        price: 0,
        limitedTimeDiscountPrice: 0,
        groupBuyingPrice: 0,
        crowdfundingPrice: 0,
        crowdfundingLotteryPrice: 0,
        pointsNum: 0,
        exchangePointsNum: 0,
        tcommodityFlashSalePrices: [
          {
            startNum: "",
            endNum: "",
            price: "",
          },
        ],
      };
    },
    getDefaultFlashSalePrice() {
      return {
        startNum: "",
        endNum: "",
        price: "",
      };
    },
    addLabel(index) {
      this.editForm.productLabelsList.splice(index + 1, 0, "");
    },
    delLabel(index) {
      if (this.editForm.productLabelsList.length === 1) {
        this.editForm.productLabelsList = [""];
      } else {
        this.editForm.productLabelsList.splice(index, 1);
      }
    },
    addSpecification(index) {
      this.editForm.commoditSpecificationsList.splice(
        index + 1,
        0,
        this.getDefaultSpecification()
      );
    },
    delSpecification(index) {
      if (this.editForm.commoditSpecificationsList.length === 1) {
        this.editForm.commoditSpecificationsList = [
          this.getDefaultSpecification(),
        ];
      } else {
        this.editForm.commoditSpecificationsList.splice(index, 1);
      }
    },
    addFlashSalePrice(specIndex, priceIndex) {
      const prices =
        this.editForm.commoditSpecificationsList[specIndex]
          .tcommodityFlashSalePrices;
      prices.splice(priceIndex + 1, 0, this.getDefaultFlashSalePrice());
    },
    delFlashSalePrice(specIndex, priceIndex) {
      const prices =
        this.editForm.commoditSpecificationsList[specIndex]
          .tcommodityFlashSalePrices;
      if (prices.length === 1) {
        prices[0] = this.getDefaultFlashSalePrice();
      } else {
        prices.splice(priceIndex, 1);
      }
    },
    handleDetailChange(value) {
      this.editForm.imgDetail = value;
    },
    handleThreeCertChange(value) {
      this.editForm.threeCertificateInformation = value;
    },
    setClassifyId(classifyIds) {
      this.classifyId = classifyIds;
    },
    getBrandList() {
      this.$axios.get("/admin/brand/getBrandListNoPage").then((res) => {
        this.supList = res.data;
      });
    },
    formatDateTime(date) {
      return parseTime(date, "{y}-{m}-{d} {h}:{i}:{s}");
    },
    getDefaultEditForm() {
      return {
        brandId: "",
        sort: 0,
        isGift: 0,
        classifyId: "",
        imgDetail: "",
        explain: "",
        intro: "",
        isGroupBuying: 0,
        unit: "",
        groupBuyingNum: "",
        limitedTimeDiscountNum: "",
        limitedTimeDiscountEndTime: "",
        isHot: 0,
        freight: "",
        isPoint: 0,
        isRecommend: 0,
        limitedTimeDiscountCommodityNum: "",
        isLimitedTimeDiscount: 0,
        isCrowdfunding: 0,
        threeCertificateInformation: "",
        crowdfundingDeliveryTime: "",
        crowdfundingEndTime: "",
        crowdfundingLuckyNum: "",
        crowdfundingLuckyUser: "",
        crowdfundingStartTime: "",
        name: "",
        productLabelsList: [""],
        parameters: "",
        videoId: "sphHynY8sojAwpC",
        videoUrl: "",
        isNewProductLaunch: 0,
        imgList: "",
        commoditSpecificationsList: [this.getDefaultSpecification()],
      };
    },
    init(commodityId, isEdit, extraParam) {
      this.isEdit = isEdit;
      if (commodityId) {
        this.commodityId = commodityId;
        this.dialogTitle = isEdit ? "编辑商品" : "添加商品";
        this.$axios
          .post("/admin/commodity/getCommodityDetail", {
            id: commodityId,
          })
          .then((res) => {
            const data = res.data;
            const specificationsList = data.commoditSpecificationsList || [];
            specificationsList.forEach((spec) => {
              if (
                !spec.tcommodityFlashSalePrices ||
                spec.tcommodityFlashSalePrices.length === 0
              ) {
                spec.tcommodityFlashSalePrices = [
                  this.getDefaultFlashSalePrice(),
                ];
              }
            });
            this.editForm = {
              sort: data.sort,
              brandId: data.brandId,
              isCrowdfunding: data.isCrowdfunding,
              classifyId: data.classifyId,
              crowdfundingDeliveryTime: data.crowdfundingDeliveryTime,
              crowdfundingEndTime: data.crowdfundingEndTime,
              crowdfundingLuckyNum: data.crowdfundingLuckyNum,
              crowdfundingLuckyUser: data.crowdfundingLuckyUser,
              crowdfundingStartTime: data.crowdfundingStartTime,
              imgDetail: data.imgDetail,
              isPoint: data.isPoint,
              limitedTimeDiscountCommodityNum:
                data.limitedTimeDiscountCommodityNum,
              isRecommend: data.isRecommend,
              threeCertificateInformation: data.threeCertificateInformation,
              explain: data.explain,
              productLabelsList: data.productLabelsList || [""],
              commoditSpecificationsList: specificationsList,
              unit: data.unit,
              isGroupBuying: data.isGroupBuying,
              groupBuyingNum: data.groupBuyingNum,
              limitedTimeDiscountEndTime: data.limitedTimeDiscountEndTime
                ? this.formatDateTime(new Date(data.limitedTimeDiscountEndTime))
                : "",
              limitedTimeDiscountNum: data.limitedTimeDiscountNum,
              freight: data.freight,
              isHot: data.isHot,
              isGift: data.isGift,
              isLimitedTimeDiscount: data.isLimitedTimeDiscount,
              isNewProductLaunch: data.isNewProductLaunch,
              name: data.name,
              parameters: data.parameters,
              imgList: data.imgList ? data.imgList.toString() : "",
            };
            setTimeout(() => {
              const classifyIds = [
                Number(data.firstClassifyId),
                "a" + data.classifyId,
              ];
              this.setClassifyId(classifyIds);
            }, 400);
            this.filesd = [];
            if (data.videoCover) {
              const coverUrls = data.videoCover.split(",");
              this.filesd = coverUrls.map((url) => ({ url }));
            }
          });
        this.dialogVisible = true;
      } else {
        this.dialogTitle = "添加商品";
        this.commodityId = "";
        this.editForm = this.getDefaultEditForm();
        this.classifyId = [];
        this.filesd = [];
        this.coverImageList = [];
        this.dialogVisible = true;
      }
    },
    handleClose() {
      this.editForm = this.getDefaultEditForm();
      this.commodityId = "";
      this.classifyId = [];
      this.filesd = [];
      this.coverImageList = [];
      this.dialogVisible = false;
    },

    getTypeList() {
      this.$axios
        .get("/admin/commodityClassify/getAllLevelList")
        .then((res) => {
          this.typeList = res.data;
        });
    },
    getImgList(url) {
      this.editForm.imgList = url;
    },

    handleCoverImageChange(url, action) {
      if (action === 1) {
        this.coverImageList.push(url);
      } else if (action === 0) {
        const index = this.coverImageList.indexOf(url);
        if (index > -1) {
          this.coverImageList.splice(index, 1);
        }
      }
      this.editForm.videoCover = this.coverImageList.join(",");
    },
    handleSave() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.classifyId.length > 0) {
          this.typeList.forEach((item) => {
            if (item.children) {
              item.children.forEach((child) => {
                if (this.classifyId[1] === child.id) {
                  this.editForm.classifyId = child.uid;
                }
              });
            }
          });
        } else {
          this.editForm.classifyId = "";
        }
        if (!this.editForm.imgList) {
          this.$message({
            showClose: true,
            message: "轮播图不能为空",
            type: "info",
          });
          return;
        }
        if (!this.editForm.parameters) {
          this.$message({
            showClose: true,
            message: "商品参数不能为空",
            type: "info",
          });
          return;
        }
        const submitData = JSON.parse(JSON.stringify(this.editForm));
        submitData.imgList = submitData.imgList.split(",");
        const apiUrl =
          this.commodityId && this.isEdit
            ? "/admin/commodity/updateCommodity"
            : "/admin/commodity/addCommodity";
        if (this.commodityId && this.isEdit) {
          submitData.id = this.commodityId;
        }

        if (
          submitData.commoditSpecificationsList &&
          submitData.commoditSpecificationsList.length > 0 &&
          submitData.commoditSpecificationsList[0].tcommodityFlashSalePrices &&
          submitData.commoditSpecificationsList[0].tcommodityFlashSalePrices
            .length > 0 &&
          !submitData.commoditSpecificationsList[0].tcommodityFlashSalePrices[0]
            .price
        ) {
          submitData.commoditSpecificationsList[0].tcommodityFlashSalePrices =
            [];
        }

        this.$axios.post(apiUrl, submitData).then((res) => {
          this.dialogVisible = false;
          this.$emit("refreshDataList");
          if (this.$parent && this.$parent.$parent) {
            this.$parent.$parent.storeGoodsStatus = submitData.status;
          }
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {
              this.$emit("changeComponent1Data", 1);
            },
          });
        });
      });
    },
  },
};
</script>

<style scoped></style>
